import { Nullable, Undefinedable } from "@/api/ApiClient";

export type ProductFormData = Undefinedable<Nullable<{
    id: string | undefined,
    codigo: string,
    codigo_cabys: string,
    existencias: number,
    costo: number,
    comision: number,
    descripcion: string,
    descripcion_fact: string,
    minimo: number,
    maximo: number,
    codigobarras: string,
    temporal: boolean,
    activo: boolean,
    precio1: number,
    precio2: number,
    precio3: number,
    precio4: number,
    imagen: string,
    imagenAsset: any,
    productfamily_id: number,
    visibilidad: number,
    exento: boolean,
    existencias_compartidas: boolean,
    tipo_producto: number,
    tipo_impuesto: string,
    porcentaje_impuesto: string,
    unidad_medida: string,
    categoryId: string,
    category?: any,
    invoiceProducts: any[],
    invoiceTemplateProducts: any[],
    quoteProducts: any[],
    settlementProducts: any[],
    creditnoteProducts: any[],
    debitnoteProduct: any[],
}>>;

export const ProductRelatedAttributes: Array<keyof ProductFormData> = ["imagenAsset", "category", "invoiceProducts", "invoiceTemplateProducts", "quoteProducts", "settlementProducts", "creditnoteProducts", "debitnoteProduct"];